import { render, staticRenderFns } from "./student-opportunity-details.vue?vue&type=template&id=085d2b66&scoped=true&"
import script from "./student-opportunity-details.vue?vue&type=script&lang=js&"
export * from "./student-opportunity-details.vue?vue&type=script&lang=js&"
import style0 from "./student-opportunity-details.vue?vue&type=style&index=0&id=085d2b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d2b66",
  null
  
)

component.options.__file = "student-opportunity-details.vue"
export default component.exports